import styled from 'styled-components'

export const Name = styled.span`
  padding-right: ${({ theme }) => theme.space.sm};
  display: inline-block;
  padding-bottom: ${({ theme }) => theme.space.sm};
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-bottom: 0;
  }
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
`
